(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-video-tabs')) {
    customElements.define('product-video-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-video-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-video-panel]'));
        this.onTabClick = this.onTabClick.bind(this);
        this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick));
      }

      disconnectedCallback() {
        this.tabs.forEach((tab) => tab.removeEventListener('click', this.onTabClick));
      }

      onTabClick(event) {
        this.activateTab(event.currentTarget);
      }

      activateTab(activeTab) {
        const activePanelId = activeTab.getAttribute('aria-controls');

        this.tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.classList.toggle('active_link', isActive);
          tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        this.panels.forEach((panel) => {
          const isActive = panel.id === activePanelId;
          panel.hidden = !isActive;
          panel.querySelector('.video-embed_gg')?.classList.toggle('active_gg', isActive);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-compare-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('compare-products')) {
    customElements.define('compare-products', class extends HTMLElement {
    connectedCallback() {
      this.selects = this.querySelectorAll('[data-compare-select]');
      this.onChange = this.onChange.bind(this);
      this.selects.forEach((select) => {
        select.addEventListener('change', this.onChange);
        this.updateColumn(select);
      });
    }

    disconnectedCallback() {
      this.selects.forEach((select) => {
        select.removeEventListener('change', this.onChange);
      });
    }

    onChange(event) {
      this.updateColumn(event.currentTarget);
    }

    updateColumn(select) {
      const column = select.getAttribute('data-compare-column');
      const handle = select.value;
      const panels = this.querySelectorAll(`[data-compare-column="${column}"] [data-compare-panel]`);
      const values = this.querySelectorAll(`[data-compare-column="${column}"] [data-compare-value]`);

      panels.forEach((panel) => {
        panel.hidden = panel.getAttribute('data-product-handle') !== handle;
      });

      values.forEach((value) => {
        value.hidden = value.getAttribute('data-product-handle') !== handle;
      });
    }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
